<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="FinPreReceivementOrderViewInfo"
                        :filter_language="['balance_mode','order_status']"
                        :filter_thousandth="['customer_receivement_amount']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        :checkflg="false"
                        ref="singleTable"
                ></wTable>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:530px">
                    <div>
                        <el-button type="primary" size="mini"  @click.native.prevent="audit()" :disabled="dataDetail.Head.order_status != 0">{{$t('getapi[941]')}}</el-button>
                        <el-button type="primary" size="mini"  @click.native.prevent="reAudit()" :disabled="dataDetail.Head.order_status != 1">{{$t('getapi[1334]')}}</el-button>
                        <el-button type="primary" size="mini"  @click.native.prevent="keep()" :disabled="dataDetail.Head.order_status != 1">{{$t('getapi[1868]')}}</el-button>
                        <el-button type="primary" size="mini"  @click.native.prevent="reKeep()" :disabled="dataDetail.Head.order_status != 2">{{$t('getapi[1869]')}}</el-button>
                    </div>
                    <table>
                        <tr>
                            <td style="width:60px;min-width:60px">{{$t('getapi[463]')}}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.order_no" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{$t('getapi[1890]')}}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.create_person" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{$t('getapi[4043]')}}</td>
                            <td style="width:60px;min-width:150px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.audit_person" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[1861]')}}</td>
                            <td>
                                <el-input type="text" size="mini" :value="dataDetail.Head.order_status_name | lanchange" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[1859]')}}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.create_date" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[4059]')}}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.audit_date" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[2610]')}}</td>
                            <td>
                                <routejump :urlNo="31" v-if="dataDetail.Head.order_status == 0">
                                <el-input
                                        v-model="dataDetail.Head.customer_code"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectvender()"></i>
                                </el-input>
                                </routejump>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.customer_code" v-if="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[2584]')}}</td>
                            <td colspan="3">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.customer_name" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[1228]')}}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.balance_mode_name" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[3287]')}}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.exchange_rate" :readonly="dataDetail.Head.order_status != 0" :class="{'readO':dataDetail.Head.order_status != 0}" @input="getReceiveAmount"></el-input>
                            </td>
                            <td>{{$t('getapi[3740]')}}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.customer_currency_code" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[8575]')}}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.customer_remain_amount" :readonly="dataDetail.Head.order_status != 0" :class="{'readO':dataDetail.Head.order_status != 0}" @input="getReceiveAmount"></el-input>
                            </td>
                            <td></td>
                            <td></td>
                            <td>{{$t('getapi[8576]')}}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.receive_amount" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[143]')}}</td>
                            <td colspan="5">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.remark" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="FinPreReceivementOrderViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[5114]')" queryData="FinPreReceivementOrderViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <!-- 客户代码 -->
        <selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage=true
                  :postUrl="'/Finance/PreMent/GetVenderCodePopuDataList'" @callback="getvender" ref="vender"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '3_prementoverview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_prementoverview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                loading: false, // 主表加载状态
                dataDetail:{
                    Head:{
                        order_no:'',
                        customer_code:'',
                        customer_name:'',
                        customer_currency_code:'',
                        exchange_rate:'',
                        balance_mode:'',
                        payment_period:'',
                        customer_net_total_amount:'',
                        create_person:'',
                        create_date:'',
                        audit_person:'',
                        audit_date:'',
                        order_status:'',
                        order_status_name:'',
                        remark:'',
                        bankaccount_name:'',
                        bankaccountnumber:'',
                        tax_rate_code:'',
                        tax_rate:'',
                        tax_id:'',
                        checkout_cycle:'',
                        currency_code_id:'',
                        balance_mode_name:''
                    },
                    Lists:[],
                },
                oldDataDetail: '',
                addoredit: 0,
                btn: {
                    audit: false,
                    reaudit: false,
                    keep:false,
                    rekeep:false
                },
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                code: '',
                oneormore: 1,
                rowindex: -1,
                selectData:[],
                scrollTop:0,
            };
        },
        beforeMount(){
            let that = this;
            that.colsort();
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('3_prementoverview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('FinPreReceivementOrderViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[5105]"),this.$t("getapi[5132]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                console.log('权限' + that.$limits.authority('plv3', 256, 1))
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv2', 254, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 254, 1) == 2) {
                    if (that.$limits.authority('plv3', 254, 1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 254, 1) == 1) {
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 254, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                            if (that.dataDetail.Head.order_status > 0) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }

                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_prementoverview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'FinPreReceivementOrderViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Finance/PreMent/PreMentOverView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndex)
                    });
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.order_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 254, 1)){
                        return
                    }
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.order_no
                                that.getDetail(row.order_no)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.order_no
                        that.getDetail(row.order_no)
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let date= Common.methods.getDate();
                that.addoredit = 0;
                that.code = ''
                that.dataDetail = {
                    Head: {
                        order_no: '',
                        create_person: that.user,
                        create_date: date,
                        audit_person: '',
                        audit_date: '',
                        customer_code: '',
                        customer_name: '',
                        customer_currency_code: '',
                        balance_mode: '',
                        balance_mode_name: '',
                        exchange_rate: '',
                        customer_receivement_amount: '',
                        order_status: 0,
                        order_status_name: that.$t('getapi[1422]'),
                        verify_flag: 0,
                        remark: '',
                        customer_remain_amount: '',
                        receive_amount: ''
                    },
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.getView();
                            if(that.addoredit == 0){
                                that.confirmAdd()
                            } else {
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "FinPreReceivementOrderViewInfo",
                    fromname: that.$t('getapi[5105]'),
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/Finance/PreMent/PreMentSaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                }
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Finance/PreMent/GetPrePaymentBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                    }
                    loadingInstance.close()
                });
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            Code: that.code,
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Finance/PreMent/DeletePrePayment', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                that.getView()
                                that.confirmAdd();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            selectvender(){
                let that = this
                that.$refs.vender.clearInput(true);
            },
            getvender(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.balance_mode = data.balance_mode
                that.dataDetail.Head.balance_mode_name = data.balance_mode_name
                that.dataDetail.Head.currency_code_id = data.currency_code_id
                that.dataDetail.Head.customer_code = data.customer_id
                that.dataDetail.Head.customer_name = data.customer_name
                that.dataDetail.Head.exchange_rate = data.exchange_rate
                that.getReceiveAmount()
            },
            audit(){
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    customer_code: that.dataDetail.Head.customer_code,
                    customer_currency_code: that.dataDetail.Head.customer_currency_code,
                    customer_receivement_amount: that.dataDetail.Head.customer_receivement_amount,
                }
                that.$http.urlpost('/Finance/PreMent/ExecuteAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            reAudit(){
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    customer_code: that.dataDetail.Head.customer_code,
                    customer_currency_code: that.dataDetail.Head.customer_currency_code,
                    customer_receivement_amount: that.dataDetail.Head.customer_receivement_amount,
                    audit_date: that.dataDetail.Head.audit_date,
                }
                that.$http.urlpost('/Finance/PreMent/ExecuteRecoveryAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            keep(){
                let that = this
                let parm = {
                    Code: that.dataDetail.Head.order_no,
                }
                that.$http.urlpost('/Finance/PreMent/KeepReceiveMent', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            reKeep(){
                let that = this
                let parm = {
                    Code: that.dataDetail.Head.order_no,
                }
                that.$http.urlpost('/Finance/PreMent/CancelKeepReceiveMent', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            getReceiveAmount(){
                let that = this
                if(that.dataDetail.Head.exchange_rate != ''){
                    that.dataDetail.Head.receive_amount = that.dataDetail.Head.customer_remain_amount * that.dataDetail.Head.exchange_rate
                } else {
                    that.dataDetail.Head.receive_amount = 0
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 254,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            },
        }
    };
</script>

<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-textarea {
        display: block;
    }
</style>
